import type { ProcessHeaderForExportParams } from '@cmg/data-grid';
import { getColDefId } from '@cmg/data-grid';
import defaultTo from 'lodash/defaultTo';

import type {
  CalendarGridContext,
  CalendarGridRowData,
} from '../components/calendar-grid/CalendarGrid.model';
import { priceRangeColDef } from '../components/calendar-grid/columns';
import { GRANULAR_PRICE_RANGE_COLUMNS } from '../hooks/useGetCalendarGridProps';

export const processHeaderCallback = ({
  column,
}: ProcessHeaderForExportParams<CalendarGridRowData, CalendarGridContext>) => {
  const headerName = defaultTo(column.getColDef().headerName, '');

  return headerName.replace('ⓘ', '').trim();
};

const GRANULAR_PRICE_RANGE_COL_IDS = GRANULAR_PRICE_RANGE_COLUMNS.map(getColDefId);

export const getColumnsToExport = (visibleColIds: string[]) => {
  const priceRangeColIndex = visibleColIds.indexOf(getColDefId(priceRangeColDef));

  /**
   * ff the price range column is not visible, we don't need to add the granular price range columns
   */
  if (priceRangeColIndex > -1) {
    return [
      ...visibleColIds.slice(0, priceRangeColIndex),
      /**
       * If the granular price range columns are already visible, we don't need to add them again
       */
      ...GRANULAR_PRICE_RANGE_COL_IDS.filter(colId => !visibleColIds.includes(colId)),
      ...visibleColIds.slice(priceRangeColIndex),
    ];
  }

  return visibleColIds;
};
